import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
  icon,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-600">
            <i className={`${icon} text-xl`}></i>
          </span>
        )}
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            {title}
          </h2>
          {subtitle && (
            <p className="mt-0.5 font-label text-sm text-foreground-600">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="inline-flex items-center gap-1 rounded-md px-2 py-1 font-label text-sm text-accent-600 transition-colors hover:text-accent-700"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-base"></i>
        </Link>
      )}
    </div>
  );
}